/** Remove trailing "by Kink" / "by KINK." suffix from catalog product titles. */
export function stripByKink(name: string | null | undefined): string {
  if (!name || typeof name !== 'string') {
    return '';
  }
  return name.replace(/\s*by\s+KINK\.?/gi, '').trim();
}
